import { useState } from 'react';
import { useParams } from 'react-router-dom';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button, Hidden, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Document_UploadFileMutation } from 'queries';

import { NotificationSeverity, showToast } from 'utils/notification-manager';

import DocumentUploadModal from './document-upload-modal';

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: '#F9F9FB',
    color: '#1C2541',
    borderRadius: '8px',
    boxShadow: 'none',
    fontSize: '14px',
    px: '16px',
  },
  buttonIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '8px',
  },
}));

type Props = {
  folderId: string;
  documentTagId?: string;
  onUploadComplete: (uploadFileData: Document_UploadFileMutation) => void;
  disabled?: boolean;
};

const DocumentUploadButton = ({ documentTagId, folderId, onUploadComplete, disabled }: Props) => {
  const classes = useStyles();
  const { portalId } = useParams<Record<string, string>>();
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleUploadComplete = (uploadFileData: Document_UploadFileMutation) => {
    showToast({
      message: 'Document uploaded successfully',
      severity: NotificationSeverity.SUCCESS,
    });
    setShowUploadModal(false);
    onUploadComplete(uploadFileData);
  };

  return (
    <div>
      <Button
        component="span"
        className={classes.button}
        color="primary"
        variant="contained"
        size="small"
        onClick={() => setShowUploadModal(true)}
        disabled={disabled !== undefined ? disabled : false}
      >
        <div className={classes.buttonIcon}>
          <FileUploadIcon />
        </div>
        <Hidden mdDown>
          <Typography>Upload</Typography>
        </Hidden>
      </Button>
      <DocumentUploadModal
        documentTagId={documentTagId}
        showModal={showUploadModal}
        setShowModal={setShowUploadModal}
        portalId={portalId}
        onUploadComplete={handleUploadComplete}
        parentId={folderId}
      />
    </div>
  );
};

export default DocumentUploadButton;
